import styled from 'styled-components'
import { vars } from '@machobear/design-system/css'
import {
  Marker as MapLibreMarker,
  MarkerProps as MapLibreMarkerProps
} from 'react-map-gl/maplibre'

import {
  BusAlt,
  MapBuilding,
  MapMarker,
  Ship,
  ShoppingBag
} from '@/components/icons'

import { ReactComponent as Pin } from './pin.svg'

interface MarkerProps
  extends Pick<MapLibreMarkerProps, 'latitude' | 'longitude'> {
  color?: string
  type?: string
  category?: string
  locationInfo?: {
    category: string
    subcategory: string
  }
}

const MarkerWrapper = styled.div`
  width: 24px;
  height: 32px;
  position: relative;
  cursor: default;

  svg.pin {
    position: absolute;
    width: 100%;
    height: 100%;
    color: ${vars.backgroundColor.white};
    filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1))
      drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.2));
  }

  svg:not(.pin) {
    position: absolute;
    color: ${vars.foregroundColor.neutral};
    bottom: 1px;
    left: 50%;
    transform: translateX(-50%);
  }

  &:hover {
    svg.pin {
      color: ${vars.backgroundColor.neutralSoftHover};
    }
  }
`

const iconMap: {
  [key: string]: any
  poi: any
  university: any
  hood: any
  default: any
} = {
  poi: {
    transit: {
      rail: <BusAlt width={15} />,
      ferry: <Ship width={14} />,
      default: <BusAlt width={15} />
    },
    shopping: {
      mall: <ShoppingBag width={16} />,
      default: <ShoppingBag width={16} />
    },
    default: <MapMarker width={20} />
  },
  university: <MapBuilding width={18} />,
  hood: <MapMarker width={20} />,
  default: <MapMarker width={20} />
}

const CenterPointMarker: React.FC<MarkerProps> = ({
  latitude,
  longitude,
  type = 'default',
  locationInfo = {}
}) => {
  const getIcon = () => {
    const { category, subcategory } = locationInfo || {}
    const typeIcons = iconMap[type] || {}
    const defaultIcon = iconMap[type]?.default || iconMap.default

    if (category) {
      return (
        typeIcons?.[category]?.[subcategory || 'default'] ??
        typeIcons?.[category]?.default ??
        defaultIcon
      )
    }
    return iconMap[type] ?? defaultIcon
  }

  return (
    <MapLibreMarker
      latitude={latitude}
      longitude={longitude}
      offset={[-4, -12]}
    >
      <MarkerWrapper>
        <Pin className="pin" />
        {getIcon()}
      </MarkerWrapper>
    </MapLibreMarker>
  )
}

export default CenterPointMarker
